import { GridColDef } from "@mui/x-data-grid";

const agentConfigDef: GridColDef[] = [
	{ field: 'agent_id', headerName: 'Agent ID', width: 200 },
	{ field: 'agent_username', headerName: 'Agent Username', width: 200 },
	{ field: 'hunt_group', headerName: 'Hunt Group', width: 200 },
];

export default agentConfigDef;